import React from 'react'

import _ from 'lodash'
import {Link} from 'react-router'

// import NavigationStore from '../stores/NavigationStore'

export default class BigBreadcrumbs extends React.Component {
  // mixins: [Reflux.listenTo(NavigationStore, 'onNavigationChange')],

  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items || [],
      icon: this.props.icon || 'fa fa-fw fa-home'
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items !== this.state.items) {
      this.setState({
        items: nextProps.items
      });
    }
  }

  onNavigationChange(data) {
    let item = data.item;
    if (item.route) {
       // eslint-disable-next-line
      this.state.items = [];
       // eslint-disable-next-line
      this.state.icon = '';
      this._addCrumb(item);
      this.forceUpdate()
    }

  }

  _addCrumb(item) {
    this.state.items.unshift(item.title)
    if (!this.state.icon && item.icon)
     // eslint-disable-next-line
      this.state.icon = item.icon
    if (item.parent)
      this._addCrumb(item.parent)
  }

  render() {
    const first = _.head(this.state.items);




    return (
      <div className={this.props.className + ' big-breadcrumbs'}>
        <h1 className="page-title txt-color-blueDark">
          <i className={this.state.icon}/>{' ' + first}
          {_.tail(this.state.items).map((item) => {
            if (_.isString(item)) {
              return <span key={_.uniqueId('big-breadcrumb-')}><span className="page-title-separator">&gt;</span>{item}</span>
            } else if (_.isArray(item)) {
              let current = '';
              let list = [];
              item.map((subItem) => {
                if (subItem.active) {
                  current = subItem.title;
                  return list.push(<li key={_.uniqueId('big-breadcrumb-dropdown-')} className="active"><Link to={subItem.route}>{subItem.title}</Link></li>);
                }
                return list.push(<li key={_.uniqueId("big-breadcrumb-dropdown-")}>
                    <Link to={subItem.route}>
                      {subItem.title}
                    </Link>
                  </li>);
              });
              return (
                <span key={_.uniqueId('big-breadcrumb-')}>
                  <span className="page-title-separator">&gt;</span>
                  <span className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{current} <span className="caret"></span></a>
                    <ul className="dropdown-menu">{list}</ul>
                  </span>
                </span>
              )
            } else if (_.isObject(item)) {
              return <span key={_.uniqueId('big-breadcrumb-')}><span className="page-title-separator">&gt;</span><Link to={item.route}>{item.title}</Link></span>
            }
            return false;
          })}
        </h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/components/BigBreadcrumbs.js